import styled from 'styled-components';

import { IconStaticProps, JustIcon, JustIconStyledComponent } from '../../../../atoms/Icon/Icon';
import toastErrorIcon from './toastError.svg';

export const ToastError = styled(JustIcon).attrs({
  alt: 'toastError',
  icon: toastErrorIcon,
  width: '32px',
  height: '32px',
})`` as JustIconStyledComponent<IconStaticProps>;
